import type { TMake } from '@src-common/api/definitions/w4d-cars-types';

import { useMakeConfig } from './useMakeConfig';

const useModelConfig = (make?: TMake, model?: string) => {
  const makeConfig = useMakeConfig(make);

  if (!makeConfig || !model) {
    return undefined;
  }

  return makeConfig.models.find(modelConfig => modelConfig.model === model);
};

export { useModelConfig };
